module.exports = "<div class=\"modal-header\">\n  <h6 class=\"modal-title pull-left\"><i style=\"color:#add8e6\" class=\"fa fa-bullhorn\" aria-hidden=\"true\"></i>&nbsp;&nbsp;Announcement</h6>\n  <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"dialogRef.close()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n<h4>\n  {{announcement}}\n</h4>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/const/announcement/announcement.component.html
// module id = ../../../../../src/app/const/announcement/announcement.component.html
// module chunks = main